import React from 'react'
import { generatePublicUrl } from '../../urlConfig'
import { Row, Col } from 'react-bootstrap';

const PaymentListOrder = ({
    item,
}) => {

    const { title, description, iconImg } = item
    const ContentBox = ({ label, value, md }) => {
        return (
            <Col md={md ? md : "6"}>
                <div className="key">{label}</div>
                <p className="value"
                    style={{
                        color: value === "" && "red"
                    }}
                >
                    {value === "" ? "Не заполнено" : value}</p>
            </Col>
        )
    }

    if (!item) return null
    return (
        <div>
            <Row>
                <ContentBox
                    md="12"
                    label="Способ"
                    value={title}
                />
            </Row>
            <Row>
                <ContentBox
                    md="12"
                    label="Подробнее"
                    value={description}
                />
            </Row>
            <Row>
                <img
                    style={{
                        width: "100px",
                        height: "auto",
                        margin: "0 auto"
                    }}
                    src={generatePublicUrl(iconImg)} alt={title} />
            </Row>
        </div>
    )
}

export default PaymentListOrder